<h2 mat-dialog-title>Información de la encuesta</h2>
<mat-dialog-content class="mat-typography">
<p>Fuiste seleccionado para participar en una encuesta de clima organizacional que el Instituto Great Place to Work® está aplicando para FS-MEXICO.</p>

<p>Tu participación es muy importante para el éxito de este estudio, toma en consideración lo siguiente:</p>
<p>• Tardarás aproximadamente 10 minutos en contestar la encuesta.</p>
<p>• Transcurrido este tiempo, si no has terminado, te pedimos cerrar y reabrir tu encuesta.</p>
<p>• Por favor, no uses los botones del navegador de internet, usa sólo los de la encuesta, que se encuentran al final de cada página.</p>
<p>Tus respuestas nos ayudarán a describir cómo es el ambiente laboral en FS-MEXICO. Esto nos permitirá conocer los puntos en los que deberán trabajar en conjunto para mejorar.</p>

<p>Responde con toda sinceridad. No hay respuestas correctas o incorrectas. Ninguna empresa es perfecta, cada una tiene cosas buenas y a mejorar.</p>

<p>El cuestionario está compuesto de preguntas que tienen 2 conjuntos de respuestas; es decir, cuando contestes cada pregunta por favor piensa en:
</p>
<p>(1) la empresa como un todo y en los jefes en general, desde tu jefe directo hasta el Director General.</p>
<p>(2) el área o departamento al que perteneces y tu jefe directo.</p>

<p>No ingreses ni tu nombre ni tu firma: Todo aquello que expreses en este cuestionario será confidencial. Tus respuestas no las conocerá nadie de tu empresa y serán resguardadas confidencialmente en el servidor de Great Place to Work®. Las respuestas participantes serán procesadas estadísticamente y computarizadas en conjunto para conocer el sentimiento general de TODOS, y no el de cada uno en particular.
</p>
<p>El valor final de esta encuesta de opinión será resultado de la sinceridad, veracidad y objetividad contenidas en todas las respuestas. Por ello, es recomendable que leas con atención cada una de las preguntas de este cuestionario y procures contestar a cada una de ellas expresando tus sentimientos reales.</p>

<h3>Muchas gracias por tu participación.</h3>

<p>Siempre puedes confiar en Great Place to Work, si deseas compartir alguna anomalía comunícate al 01 800- 5068338 o escríbenos un correo a:
mx_transparencia@greatplacetowork.com</p>

</mat-dialog-content>
